import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getUserById,
  getTeamDataTable,
  getUserRoles,
  updateGender,
  unblockUser,
  updateUserName,
  updateUserRoles,
  setUserEmail,
  setUserPassword,
  softDeleteUser,
  blockUser,
  createAdmin,
} from './thunks';
import { TeamState } from './types';

export const name = 'roles';

const initialState: TeamState = {
  data: null,
  details: null,
  userRoles: null,
  status: 'idle',
  updateStatus: 'idle',
};
export const getTeamDataTableAsync = createAsyncThunk(
  name + '/getTeamDataTable',
  getTeamDataTable
);

export const getUserByIdAsync = createAsyncThunk(
  name + '/getUserById',
  getUserById
);

export const getUserRolesAsync = createAsyncThunk(
  name + '/getUserRoles',
  getUserRoles
);

export const updateGenderAsync = createAsyncThunk(
  name + '/updateGender',
  updateGender
);

export const unblockUserAsync = createAsyncThunk(
  name + '/unblockUser',
  unblockUser
);

export const updateUserNameAsync = createAsyncThunk(
  name + '/updateUserName',
  updateUserName
);

export const updateUserRolesAsync = createAsyncThunk(
  name + '/updateUserRoles',
  updateUserRoles
);

export const setUserEmailAsync = createAsyncThunk(
  name + '/setUserEmail',
  setUserEmail
);

export const setUserPasswordAsync = createAsyncThunk(
  name + '/setUserPassword',
  setUserPassword
);

export const softDeleteUserAsync = createAsyncThunk(
  name + '/softDeleteUser',
  softDeleteUser
);

export const blockUserAsync = createAsyncThunk(name + '/blockUser', blockUser);

export const createAdminAsync = createAsyncThunk(
  name + '/createAdmin',
  createAdmin
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
    clearDetails: (state) => {
      state.details = null;
    },
    clearUserRoles: (state) => {
      state.userRoles = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTeamDataTableAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getTeamDataTableAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getTeamDataTableAsync.rejected, (state) => {
        state.status = 'idle';
      })

      .addCase(getUserByIdAsync.fulfilled, (state, action) => {
        state.details = action.payload;
      })
      .addCase(getUserRolesAsync.fulfilled, (state, action) => {
        state.userRoles = action.payload;
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
